import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { createDiagram, fetchDiagrams } from '../../../../redux/reducers/global/diagram/diagramSlice';
import './NewDiagramModalContentStyle.css';

function NewDiagramModalContent({ onClose }) {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    label: '',
    description: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        ...formData,
        folder: null,
        isNewFolder: false,
      };
      // Create the diagram and wait for completion
      await dispatch(createDiagram(payload)).unwrap();
      // Refresh diagram list so UI updates immediately
      dispatch(fetchDiagrams());
      // Close the modal after successful creation
      onClose();
    } catch (err) {
      console.error('Failed to create diagram:', err);
    }
  };

  return (
    <div className="modal-create modal-create--diagram">
      <h2>Crear Nuevo Diagrama</h2>
      <form onSubmit={handleSubmit}>
        <label>
          <div>Nombre: </div>
          <input
            type="text"
            name="label"
            className="input-nombre"
            value={formData.label}
            onChange={handleInputChange}
            autocomplete="off"
            required
          />
        </label>

        <label>
          <div>Descripción: </div>
          <input
            name="description"
            value={formData.description}
            onChange={handleInputChange}
            autocomplete="off"
            required
          />
        </label>

        <div className="modal-buttons">
          <button type="button" onClick={onClose} className="btn-cancel">
            Cancelar
          </button>
          <button type="submit" className="btn-submit">
            Crear
          </button>
        </div>
      </form>
    </div>
  );
}

export default NewDiagramModalContent;
